import React, { useEffect, useMemo, useRef, useState } from 'react'
import './MediaControlPanel.css'
import MediaControlButton from '../MediaControlButton/MediaControlButton.jsx'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import MediaControlMenu from '../MediaControlMenu/MediaControlMenu.jsx'
import {
    setSelectedMic,
    setSelectedSpeaker,
    setSelectedCamera,
    setSelectedEffect,
    setMicLoading,
    setCameraLoading,
    setScreenShareLoading,
    toggleSpeaker
}
    from '../../store/mediaControlSlice.js'
import {
    toggleLivekitMic,
    toggleLivekitCamera,
    toggleLivekitScreenShare
} from '../../../MediaPlayback/store/livekitSlice/livekitSlice.js'
import { setOpenModal } from '../../../ControlPanel/store/controlPanelSlice.js'
import { updateUserDeviceState } from '../../store/mediaControlThunks.js'
import socketFactory, { mapSocketFactory } from '../../../../utils/socketFactory.js'
import { useCallback } from 'react'
import TranscriptionButton from "../TranscriptionButton/TranscriptionButton.jsx";
import { hasPermission, tenantHasFeature } from "../../../Auth/utils/AuthUtils";
import { setIsSuperSpeakerActive } from '../../../ControlPanel/store/Announcement/AnnouncementSlice.js'
import { toggleGlobalLivekitMic } from '../../../MediaPlayback/store/GlobalLivekitSlice/GlobalLivekitSlice.js'
import { getTransciptionService } from "../../../MediaPlayback/Transcription/TranscriptionService";
import ReactionMenu from "../ReactionMenu/ReactionMenu.jsx";
import { addReaction, sendReaction } from "../../store/reactionSlice.js";
import { raiseHand, lowerHand, RAISE_HAND_TO_ROOM, LOWER_HAND_TO_ROOM } from "../../store/raisedHandsSlice.js";
import ConnectionQualityIndicator from '../ConnectionQualityIndicator/ConnectionQualityIndicator';
import { useNavigate } from 'react-router-dom'
import { createPortal } from "react-dom";
import { useFloating, shift, flip, offset, autoUpdate } from "@floating-ui/react";
import { setConferenceFunction, setIsConferencePanelOpen } from '../../../Conference/store/ActiveConferenceSlice.js'
import ConferenceParticipant from '../../../Conference/components/conferenceParticipant/ConferenceParticipant.jsx'
import ModerateParticipants from '../../../Conference/components/moderateParticipants/ModerateParticipants.jsx'
import { getBookingById } from '../../../Map/store/RoomMenu/RoomMenuThunks.js'
import { setInitialReservation, setShowReservationPopup, setUpdateRoom } from '../../../Map/store/RoomMenu/RoomMenuSlice.js'
import { setSelectedRoomupdate } from '../../../ControlPanel/store/AddEvent/AddEventSlice.js'
import AgentControlPanel from '../AgentControlPanel/AgentControlPanel.js'
import ConferenceMessaging from '../../../Conference/components/conferenceMessages/ConferenceMessaging.jsx'
import { useScreenRecorder } from "../../../ScreenRecording/hooks/useScreenRecorder.js";
import { getConferenceUserParams } from '../../../../utils/conferenceUtils.js'

import { useRoomRecording } from "../../../ScreenRecording/hooks/useRoomRecording.js";

import  PreviewModal  from '../../../ScreenRecording/components/PreviewModal.jsx';
import { setRecorderStatus, setRecorderData } from '../../../ScreenRecording/slice/recorderSlice.js';
import { registerRecordingHandlers, triggerRecordingStart, triggerRecordingStop } from "../../../ScreenRecording/hooks/useRoomRecording.js";

export default function MediaControlPanel({ }) {

    const hands = useSelector((state) => state.raisedHands.list);
    const {
        micActive,
        speakerActive,
        cameraActive,
        micLoading,
        speakerLoading,
        cameraLoading,
        screenShareLoading,
        screenShareActive,
        selectedMic,
        selectedSpeaker,
        selectedCamera,
        mics,
        speakers,
        cameras,
        speakerPermission,
        micPermission,
        cameraPermission,
        selectedEffect,
    } = useSelector((state) => state.mediaControls) ;

    const recorder = useScreenRecorder(micActive);
    const {
        status,
        duration,
        videoUrl,
        isRecording,
        startRecording,
        stopRecording,
        downloadRecording,
        resetRecording,
    } = recorder;


    const localAvatar = useSelector((state) => state.auth.localAvatar);
    const currentRoom = useSelector((state) => state.MapDisplay.currentRoom);

    const {
        notifyRecordingStarted,
        notifyRecordingStopped,
      } = useRoomRecording(currentRoom, localAvatar);

      const recorderState = useSelector(
        (state) => state.recorder
    );
      const isAnotherUserRecording = recorderState.status === "recording" && !recorderState.isOwner;

      const handleRecordClick = async () => {

        if (isRecording) {
    
            await triggerRecordingStop();
    
        } else {
    
            await triggerRecordingStart();
        }
    
        setOpenMore(false);
    
        if (isMobile) {
            setMoreActionMobile(false);
        }
    };
    
    /*-------------- LOGIC -------------- */
    const { t } = useTranslation()
    const navigate = useNavigate();

    const { openModal } = useSelector((state) => state.controlPanel)
    const { whiteboardActive, whiteboardId } = useSelector((state) => state.whiteboard);
    const { uiState, conference } = useSelector((state) => state.activeConference);
    const avatarsData = useSelector((state) => state.avatars?.avatars || {});

    const { focusSessionActive } = useSelector((state) => state.productivitySession);
    const [openMore, setOpenMore] = useState(false);
    const { refs, floatingStyles } = useFloating({ placement: "bottom-center", middleware: [offset(6), flip(), shift(),], whileElementsMounted: autoUpdate, })
    const{
        livekitMicActive,
        livekitCameraActive,
        livekitScreenShareActive,
    } = useSelector((state) => state.livekit);
    
    function useMobile() {
        const [isMobile, setIsMobile] = useState(window.innerWidth < 480);

        useEffect(() => {
            const handleResize = () => {
                setIsMobile(window.innerWidth < 480);
            };

            window.addEventListener('resize', handleResize);

            // Nettoyage
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return isMobile;
    }


    const isMobile = useMobile();

    const [moreActionMobile, setMoreActionMobile] = useState(false);
    const {
        cafePauseStartTime
    } = useSelector((state) => state.coffePause);

    

    const dispatch = useDispatch()
    const panelRef = useRef(null)
    // The server resets the device states on disconnect
    // Update the database with the device states
    useEffect(() => {
        const deviceStates = {
            // convert boolean states to numbers for the database
            mic_state: + micActive,
            speaker_state: + speakerActive,
            camera_state: + cameraActive,
            screenshare_state: + screenShareActive,
            focus_state: + focusSessionActive,
            break_coffe_time: cafePauseStartTime
        }

        

        // Dispatch the thunk to update the user device state on render or when a device state changes
        dispatch(updateUserDeviceState({ body: deviceStates }))

        // And again whenever a new socket connection is established.
        const connectListner = () => { dispatch(updateUserDeviceState({ body: deviceStates })) };
        socketFactory.on("connect", connectListner);
        return () => {
            socketFactory.off("connect", connectListner)
        }
    }
        , [micActive, speakerActive, cameraActive, screenShareActive, focusSessionActive])


    const handleSettingsClick = () => {
        dispatch(setOpenModal('settings'))
    }

    const effectList = [
        {
            id: "none",
            label: "Aucun effet",
            icon: "blur_off",
        },
        {
            id: "blur",
            label: "Arriere plan flou",
            icon: "blur_on",
        },
        {
            id: "background",
            label: "Arriere plan image",
            icon: "filter",
        }
    ]

    const onCameraClick = useCallback(() => {
        if (cameraLoading) {
            // Prevent toggling if already loading
            dispatch(toggleLivekitCamera(false))
            return
        }
        if (!cameraActive) {
            dispatch(setCameraLoading(true))
        }
        dispatch(toggleLivekitCamera(!cameraActive))
    }
        , [cameraActive, cameraLoading]);

    const onScreenShareClick = useCallback(() => {
        if (screenShareLoading) {
            // Prevent toggling if already loading
            console.log("Screen share is loading, please wait...");
            dispatch(toggleLivekitScreenShare(false))
            return
        }
        if (!screenShareLoading) {
            dispatch(setScreenShareLoading(true))
        }
        dispatch(toggleLivekitScreenShare(!screenShareActive));
        setMoreActionMobile(false)
    }
        , [screenShareActive, screenShareLoading]);



    /*-------------- GLOBAL ANNOUNCEMENT MICROPHONE SYNCRONIZATION -------------- */

    const { globalLivekitMic } = useSelector((state) => state.globalLivekit)
    const { TSstatus, isOwner, TSChecking } = useSelector(
        (state) => state.transcription
    );
    
    const senderName =
        localAvatar?.display_name ||
        localAvatar?.displayName ||
        localAvatar?.name ||
        localAvatar?.label ||
        "";
const {  myUser } = getConferenceUserParams(
        conference,
        avatarsData,
        localAvatar,
        uiState.is_conference_active
    );
    const allowMic = myUser?.accesses?.[0]?.allow_mic;
            const allowCamera = myUser?.accesses?.[0]?.allow_camera;
            const allowScreenShare = myUser?.accesses?.[0]?.allow_screen_share; 
            const allowReaction = conference?.allow_reaction ?? true; 
            const myRole = myUser?.role; 
            const isAllowReactionDisabled = !allowReaction && myRole !== 'master' && myRole !== 'principal-master';
            const isMicDisabled = myUser ? (allowMic === false) : false;
            const isCameraDisabled = myUser ? (allowCamera === false) : false;
            const isScreenShareDisabled = myUser ? (allowScreenShare === false) : false;
           
 useEffect(() => {
                if (myUser) {
                   
                        if (allowMic === false && livekitMicActive) {
                            dispatch(toggleLivekitMic(false))
                        }
                        if (allowCamera === false && livekitCameraActive) {
                            dispatch(toggleLivekitCamera(false))
                        }
                        if (allowScreenShare === false && livekitScreenShareActive) {
                            dispatch(toggleLivekitScreenShare(false))
                        }
                    
                }
            }, [allowScreenShare, allowCamera, allowMic, myUser]);

    // recorder 
    useEffect(() => {
        dispatch(setRecorderStatus(status));
    }, [status]);

    useEffect(() => {
        dispatch(setRecorderData({
            duration,
        }));
    }, [duration]);

    useEffect(() => {
        registerRecordingHandlers({
            onStart: async () => {
                const success = await startRecording();
                if (!success) return;
                notifyRecordingStarted();
            },
            onStop: async () => {
                await stopRecording();
                notifyRecordingStopped();
            },
        });

    }, [startRecording,stopRecording,notifyRecordingStarted,notifyRecordingStopped,]);

    useEffect(() => {
        if (globalLivekitMic && micActive)
            dispatch(toggleLivekitMic(false))
    }, [globalLivekitMic])


    // Dans MediaControlPanel.js
    const onWhiteboardClick = useCallback(() => {
        const newState = !whiteboardActive;
        // On émet vers le serveur
        mapSocketFactory.socket.emit("createWhiteboard", {
            roomId: currentRoom.room_id,
            boardId: 'whiteboard-' + localAvatar?.id,
            active: newState,
            owner: localAvatar?.email
        });
        setOpenMore(false)
        if (isMobile) {
            setMoreActionMobile(false)
        }
    }, [localAvatar?.id, currentRoom, whiteboardActive])

    const onMicrophoneClick = useCallback(() => {
        if (!globalLivekitMic) {
            if (micLoading) {
                // Prevent toggling if already loading
                dispatch(toggleLivekitMic(false))
                return
            }
            if (!micActive) {
                dispatch(setMicLoading(true))
            }
            dispatch(toggleLivekitMic(!micActive))
        }
        else {
            dispatch(toggleGlobalLivekitMic(false))
            dispatch(setIsSuperSpeakerActive(false))
        }
    }
        , [micActive, micLoading, globalLivekitMic]);

    const toggleTranscription = useCallback(() => {
        const service = getTransciptionService();
        if (!service) return;

        if (TSstatus === "active") {
            service.stopTranscription();
        } else if (TSstatus === "inactive") {
            service.activateTranscription();
        }
        setMoreActionMobile(false);
        setOpenMore(false);
    }, [TSstatus]);

    const menuMobileRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuMobileRef.current &&
                !menuMobileRef.current.contains(event.target)
            ) {
                setMoreActionMobile(false);
            }
        };

        if (moreActionMobile) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [moreActionMobile]);


    useEffect(() => {
        console.log('MediaControlPanel mounted');
        return () => console.log('MediaControlPanel unmounted');
    }, []);
    // console.log("TRANSCRIPTION_ENABLED:", tenantHasFeature("TRANSCRIPTION_ENABLED"));

    /*-------------- RENDERING -------------- */
    return (
        <>
        
            <div className="control-panel" ref={panelRef}>
                <ConnectionQualityIndicator />
                <div className='control-buttons'>

                    <div className='control-button-wrapper'>
                        <MediaControlButton
                            id="tour-btn"
                            name="Speaker"
                            onClick={() => { dispatch(toggleSpeaker(!speakerActive)) }}
                            onChevronClick={() => { dispatch(setOpenModal(openModal === "speaker-control-menu" ? null : "speaker-control-menu")) }}
                            hasChevron={true}
                            loading={speakerLoading}
                            active={speakerActive}
                            disabled={false}
                            activeIcon={"volume_up"}
                            inactiveIcon={"volume_off"}
                            activeTooltip={t("speaker_active_tooltip")}
                            inactiveTooltip={t("speaker_inactive_tooltip")}
                            anchorEl={panelRef.current}
                        />

                        <MediaControlMenu
                            isOpen={openModal === "speaker-control-menu"}
                            deviceType="audiooutput"
                            headerIcon="volume_up"
                            headerText={t("speaker_selection_menu_header")}
                            selectedDevice={selectedSpeaker}
                            devices={speakers}
                            handleDeviceSelection={(device) => { dispatch(setSelectedSpeaker(device)) }}
                            deviceActive={speakerActive}
                            devicePermission={speakerPermission}
                            settingsButtonLabel={t("device_settings_button_label")}
                            handleSettingsClick={handleSettingsClick}
                            onClickAway={() => { dispatch(setOpenModal(null)) }}
                        />
                    </div>


                    <div className='control-button-wrapper'>
                        <MediaControlButton
                            name="Microphone"
                            onClick={onMicrophoneClick}
                            onChevronClick={() => { dispatch(setOpenModal(openModal === "microphone-control-menu" ? null : "microphone-control-menu")) }}
                            hasChevron={true}
                            loading={micLoading}
                            active={globalLivekitMic || micActive}
                            disabled={isMicDisabled}
                            activeIcon={"mic"}
                            inactiveIcon={"mic_off"}
                            activeTooltip={t("mic_active_tooltip")}
                            inactiveTooltip={t("mic_inactive_tooltip")}
                            anchorEl={panelRef.current}
                        />

                        <MediaControlMenu
                            isOpen={openModal === "microphone-control-menu"}
                            deviceType="microphone"
                            headerIcon="mic"
                            headerText={t("mic_selection_menu_header")}
                            selectedDevice={selectedMic}
                            devices={mics}
                            handleDeviceSelection={(device) => { dispatch(setSelectedMic(device)) }}
                            deviceActive={micActive}
                            devicePermission={micPermission}
                            settingsButtonLabel={t("device_settings_button_label")}
                            handleSettingsClick={handleSettingsClick}
                            onClickAway={() => { dispatch(setOpenModal(null)) }}
                        />
                    </div>

                    <div className='control-button-wrapper'>
                        <MediaControlButton
                            name="Camera"
                            onClick={onCameraClick}
                            onChevronClick={() => { dispatch(setOpenModal(openModal === "camera-control-menu" ? null : "camera-control-menu")) }}
                            hasChevron={true}
                            loading={cameraLoading}
                            active={cameraActive}
                            disabled={isCameraDisabled}
                            activeIcon={"videocam"}
                            inactiveIcon={"videocam_off"}
                            activeTooltip={t("camera_active_tooltip")}
                            inactiveTooltip={t("camera_inactive_tooltip")}
                            anchorEl={panelRef.current}
                        />
                        <MediaControlMenu
                            isOpen={openModal === "camera-control-menu"}
                            deviceType="camera"
                            headerIcon="videocam"
                            headerText={t("camera_selection_menu_header")}
                            selectedDevice={selectedCamera}
                            devices={cameras}
                            handleDeviceSelection={(device) => { dispatch(setSelectedCamera(device)) }}
                            deviceActive={cameraActive}
                            devicePermission={cameraPermission}
                            settingsButtonLabel={t("device_settings_button_label")}
                            handleSettingsClick={handleSettingsClick}
                            onClickAway={() => { dispatch(setOpenModal(null)) }}

                            isVideoMenu={true}
                            selectedEffect={selectedEffect}
                            effectEnabled={true}
                            handleSelectEffect={(effect) => dispatch(setSelectedEffect(effect))}
                            effectList={effectList}

                        />

                    </div>

                    {
                        isMobile &&
                        <button className='control-btn icon-more' onClick={() => setMoreActionMobile(prev => !prev)}>
                            <span className="material-symbols-outlined">
                                more_horiz
                            </span>
                        </button>
                    }

                    {!isMobile &&
                        <>
                            <div className='control-button-wrapper' style={{ position: "relative" }}>
                                <MediaControlButton
                                    name="reactions"
                                    onClick={() =>
                                        dispatch(setOpenModal(openModal === "reaction-menu" ? null : "reaction-menu"))
                                    }
                                    hasChevron={false}
                                    inactiveIcon={"add_reaction"}
                                    disabled={isAllowReactionDisabled}
                                    inactiveTooltip={t("reaction_tooltip")}
                                    inactiveStyle="reaction-icon"
                                    anchorEl={panelRef.current}
                                />

                                {openModal === "reaction-menu" && (
                                    <ReactionMenu
                                        onSelectReaction={(r) => {
                                            dispatch(setOpenModal(null));
                                            dispatch(
                                                sendReaction({
                                                    id: Date.now(),
                                                    sender: localAvatar?.id,
                                                    senderName,
                                                    roomId: currentRoom?.room_id,
                                                    emoji: r.emoji,
                                                    gif: r.gif
                                                })
                                            );
                                        }}
                                        onRaiseHand={() => {
                                            dispatch(setOpenModal(null));

                                            const handAlreadyUp = hands.some(h => h.sender === localAvatar?.id);

                                            if (!handAlreadyUp) {
                                                dispatch(raiseHand({
                                                    sender: localAvatar?.id,
                                                    senderName,
                                                    time: Date.now()
                                                }));

                                                RAISE_HAND_TO_ROOM({
                                                    sender: localAvatar?.id,
                                                    senderEmail: localAvatar?.email,
                                                    senderName,
                                                    roomId: currentRoom?.room_id
                                                });

                                                dispatch(
                                                    sendReaction({
                                                        id: Date.now(),
                                                        sender: localAvatar?.id,
                                                        senderName,
                                                        roomId: currentRoom?.room_id,
                                                        emoji: "✋",
                                                        gif: "/reactions/Raised_hand.gif"
                                                    })
                                                );

                                            } else {
                                                dispatch(lowerHand(localAvatar?.id));
                                                LOWER_HAND_TO_ROOM({
                                                    sender: localAvatar?.id,
                                                    senderEmail: localAvatar?.email,
                                                    roomId: currentRoom?.room_id
                                                });
                                            }
                                        }}
                                    />
                                )}
                            </div>

                            <MediaControlButton
                                id="ScreenShare"
                                name="Screen Share"
                                onClick={onScreenShareClick}
                                loading={screenShareLoading}
                                active={screenShareActive}
                                disabled={isScreenShareDisabled}
                                activeIcon={"screen_share"}
                                inactiveIcon={"screen_share"}
                                activeStyle="icon-screenshare-active"
                                inactiveStyle="icon-screenshare-inactive"
                                activeTooltip={t("screen_share_active_tooltip")}
                                inactiveTooltip={t("screen_share_inactive_tooltip")}
                                anchorEl={panelRef.current}
                            />

                            <button className='control-btn icon-more' ref={refs.setReference} onClick={(e) => {
                                e.stopPropagation();
                                setOpenMore(prev => !prev);
                            }}>
                                <span className="material-symbols-outlined">
                                    more_horiz
                                </span>
                            </button>

                            {openMore &&
                                createPortal(

                                    <div className='more-actions-menue' ref={refs.setFloating} style={floatingStyles}>
                                     {tenantHasFeature("RECORD_SYSTEM_ENABLED") && (
                                        <MediaControlButton
                                            name="record"
                                            onClick={handleRecordClick}
                                            hasChevron={false}
                                            loading={false}
                                            inactiveStyle="reaction-icon"
                                            active={status === "recording"}
                                            disabled={isAnotherUserRecording}
                                            activeIcon={"radio_button_checked"}
                                            inactiveIcon={"fiber_manual_record"}
                                            anchorEl={panelRef.current}
                                        /> )}



                                        {tenantHasFeature("TRANSCRIPTION_ENABLED") && (
                                            <div className="control-button-wrapper">
                                                <TranscriptionButton
                                                   onToggle={toggleTranscription}
                                                   anchorEl={panelRef.current}
                                                />
                                            </div>
                                        )}
                                        
                                        <MediaControlButton
                                            name="whiteboard"
                                            hasChevron={false}
                                            inactiveIcon={"jamboard_kiosk"}
                                            inactiveTooltip={t("whiteboard_tooltip")}
                                            inactiveStyle="reaction-icon"
                                            anchorEl={panelRef.current}
                                            onClick={onWhiteboardClick}
                                            disabled={whiteboardActive && whiteboardId !== null && whiteboardId !== 'whiteboard-' + localAvatar?.id}
                                        />
                                        
                                        
                                    </div>, document.body
                                )}
                        </>
                    }
                </div>
            </div>

            {isMobile && moreActionMobile &&
                <div   id="tour-mobile"
                className={`other-action ${moreActionMobile ? 'open' : ''}`} ref={menuMobileRef}>
                    <div className='control-button-wrapper' style={{ position: "relative" }}>
                        <ReactionMenu
                            onSelectReaction={(r) => {
                                dispatch(setOpenModal(null));
                                dispatch(
                                    sendReaction({
                                        id: Date.now(),
                                        sender: localAvatar?.id,
                                        senderName,
                                        roomId: currentRoom?.room_id,
                                        emoji: r.emoji,
                                        gif: r.gif
                                    })
                                );
                            }}
                            onRaiseHand={() => {
                                dispatch(setOpenModal(null));

                                const handAlreadyUp = hands.some(h => h.sender === localAvatar?.id);

                                if (!handAlreadyUp) {
                                    dispatch(raiseHand({
                                        sender: localAvatar?.id,
                                        senderName,
                                        time: Date.now()
                                    }));

                                    RAISE_HAND_TO_ROOM({
                                        sender: localAvatar?.id,
                                        senderEmail: localAvatar?.email,
                                        senderName,
                                        roomId: currentRoom?.room_id
                                    });

                                    dispatch(
                                        sendReaction({
                                            id: Date.now(),
                                            sender: localAvatar?.id,
                                            senderName,
                                            roomId: currentRoom?.room_id,
                                            emoji: "✋",
                                            gif: "/reactions/Raised_hand.gif"
                                        })
                                    );

                                } else {
                                    dispatch(lowerHand(localAvatar?.id));
                                    LOWER_HAND_TO_ROOM({
                                        sender: localAvatar?.id,
                                        senderEmail: localAvatar?.email,
                                        roomId: currentRoom?.room_id
                                    });
                                }
                            }}
                        />
                    </div>

                    <div className='other-buttons'>
                        <MediaControlButton
                            name="Screen Share"
                            onClick={onScreenShareClick}
                            loading={screenShareLoading}
                            active={screenShareActive}
                            disabled={false}
                            activeIcon={"screen_share"}
                            inactiveIcon={"screen_share"}
                            activeStyle="icon-screenshare-active"
                            inactiveStyle="icon-screenshare-inactive"
                            activeTooltip={t("screen_share_active_tooltip")}
                            inactiveTooltip={t("screen_share_inactive_tooltip")}
                            anchorEl={panelRef.current}
                        />
         
                        {tenantHasFeature("TRANSCRIPTION_ENABLED") && (
                            <div className="control-button-wrapper">
                                <TranscriptionButton
                                    onToggle={toggleTranscription}
                                    anchorEl={panelRef.current}
                                />
                            </div>
                        )}
                             {
                                            hasPermission("admin") && (
                                                <AgentControlPanel
                                                    name="whiteboard"
                                                    hasChevron={false}
                                                    activeIcon={"smart_toy"}
                                                    inactiveIcon={"auto_awesome"}
                                                    inactiveStyle="reaction-icon"
                                                    anchorEl={panelRef.current}
                                                />
                                            )}

                        <MediaControlButton
                            name="whiteboard"
                            hasChevron={false}
                            inactiveIcon={"jamboard_kiosk"}
                            inactiveTooltip={t("whiteboard_tooltip")}
                            inactiveStyle="reaction-icon"
                            anchorEl={panelRef.current}
                            onClick={onWhiteboardClick}
                            disabled={whiteboardActive && whiteboardId !== null && whiteboardId !== 'whiteboard-' + localAvatar?.id}
                        />
                         {tenantHasFeature("RECORD_SYSTEM_ENABLED") && (

                        <MediaControlButton
                            name="record"
                            onClick={handleRecordClick}
                            hasChevron={false}
                            loading={false}
                            active={status === "recording"}
                            disabled={isAnotherUserRecording}
                            anchorEl={panelRef.current}
                        />)}
                            
                    </div>

                </div>
            }

             {/* ScreenRecording overlays */}
            <PreviewModal
                videoUrl={videoUrl}
                onDownload={downloadRecording}
                onReset={resetRecording}
            />

        </>
    )
}
